import {
  Component,
  EventEmitter,
  Injectable,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  IconoirHalfMoon,
  IconoirHelpCircle,
  IconoirLogOut,
  IconoirMoreHoriz,
  IconoirSettings,
  IconoirSunLight,
  IconoirUser,
} from '@ey-xd/motif-icon';
import { MotifModule } from "@ey-xd/motif-wc-angular"; 
import { IProfileType } from 'app/core/service/auth/profile';
import { Subject, Subscription, take, takeUntil } from 'rxjs';
import { HeaderTitleService } from 'services/header-title.service';
import { AuthenticationService } from '../../service/auth/authentication.service';
import { FeedbackService } from 'app/core/service/feedback/feedback.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ModalExportSurverys } from '../survey-export-modal/survey-export-modal.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    MotifModule,
    ModalExportSurverys,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
@Injectable({
providedIn: 'root', // Automatically registers the service globally
})
export class HeaderComponent implements OnInit, OnDestroy {
  IconoirSunLight = IconoirSunLight;
  IconoirHalfMoon = IconoirHalfMoon;
  IconoirUser = IconoirUser;
  IconoirMoreHoriz = IconoirMoreHoriz;
  IconoirLogOut = IconoirLogOut;
  IconoirSettings = IconoirSettings;
  IconoirHelpCircle = IconoirHelpCircle;

  // Placement = Placement;
  // ScrollStrategy = ScrollStrategy;

  showSurveyExportModal: boolean = false;
  
  @Output() changeThemeEvent = new EventEmitter();
  @Output() toggleMenuEvent = new EventEmitter();

  menuIconSize: string = String(36);

  theme: string = 'dark';
  showMenu: boolean = false;

  title: string = '';
  profile?: IProfileType;

  private _destroy$ = new Subject<void>();

  constructor(
    private authenticationService: AuthenticationService,
    private headerTitleService: HeaderTitleService,
    private feedbackService: FeedbackService,
  ) {}
  
  isAdmin: boolean = false;
  private titleSubscription?: Subscription;

  ngOnInit(): void {
    this.headerTitleSubscribe();
    this.profileSubscribe();
    this.getMeRole();
  }

  private headerTitleSubscribe(): void {
    this.headerTitleService.headerTitle$
      .pipe(takeUntil(this._destroy$))
      .subscribe((title: string | undefined) => {
        this.title = title || 'CIT Agent';
      });
  }

  private profileSubscribe(): void {
    this.authenticationService
      .isLoggedIn()
      .pipe(takeUntil(this._destroy$))
      .subscribe((loggedIn: boolean) => {
        if (loggedIn) {
          this.authenticationService
            .getProfile()
            .pipe(take(1))
            .subscribe((profile: IProfileType) => {
              // TODO fix profile discrepancy, see console.log output:
              // console.log(
              //   'profile',
              //   profile,
              //   this.authenticationService.profile
              // );
              this.profile = profile;
            });
        }
      });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  toggleMenu(): void {
    this.showMenu = !this.showMenu;
    this.toggleMenuEvent.emit();
  }

  toggleTheme() {
    this.changeThemeEvent.emit();
  }

  logout() {
    this.authenticationService.logout();
  }

  openSurveyExportModal() {
    this.showSurveyExportModal = true;
  }

  closeSurveyExportModal() {
    this.showSurveyExportModal = false;
  }

  getMeRole() {
    this.feedbackService.getMeRole('').subscribe({
      next: (data: any) => {
        console.log('data role');
        console.log(data.role);
        if (data.role === 1) {
          this.isAdmin = true;
        } else {
          this.isAdmin = false;
        }
      },
      error: (error: HttpErrorResponse) => {},
    });
  }


}
